// import api, { DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api'
import { context, propagation, trace } from '@opentelemetry/api'
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import {
  CompositePropagator,
  W3CBaggagePropagator,
  W3CTraceContextPropagator,
} from '@opentelemetry/core'
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { BatchSpanProcessor, TracerProvider } from '@opentelemetry/sdk-trace'
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions'

import { API_BASE_URL, APP_VERSION, CURRENT_ENV, CURRENT_MUTATION } from '@common/config'

// if (IS_LOCAL_ENV) {
//   api.diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.DEBUG)
// }

// The SemanticResourceAttributes is an enum that provides a set of predefined attribute keys for commonly used attributes in OpenTelemetry to maintain consistency across different OpenTelemetry implementations
const resource = resourceFromAttributes({
  [ATTR_SERVICE_NAME]: `order-tracking-client-${CURRENT_MUTATION}-${CURRENT_ENV}`,
  [ATTR_SERVICE_VERSION]: APP_VERSION,
})

// this endpoint contains a path since this exporter is signal specific (traces)
// send it to Eshop Admin server to avoid exposing NewRelic API key, see: https://docs.newrelic.com/docs/more-integrations/open-source-telemetry-integrations/opentelemetry/best-practices/opentelemetry-best-practices-browser
const exporter = new OTLPTraceExporter({
  url: `${API_BASE_URL}/otel/traces`,
  headers: {}, // needs to be here to send data using xhr instead of sendBeacon, see: https://github.com/open-telemetry/opentelemetry-js/issues/3062#issuecomment-1189189494
})

const provider = new TracerProvider({
  resource,
  spanProcessors: [
    // Uncomment this to enable debugging using consoleExporter
    // new SimpleSpanProcessor(new ConsoleSpanExporter()),
    // The BatchSpanProcessor is responsible for batching and exporting spans to the configured exporter (newRelicExporter in this case).
    new BatchSpanProcessor({ exporter }),
  ],
})

trace.setGlobalTracerProvider(provider)
// ZoneContextManager is a context manager implementation based on the Zone.js library. It enables context propagation within the application using zones.
context.setGlobalContextManager(new ZoneContextManager().enable())
// Configure the propagator to enable context propagation between services using the W3C Trace Headers
propagation.setGlobalPropagator(
  new CompositePropagator({
    propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
  }),
)

export const init = () => {
  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-xml-http-request': {
          // third-party servers reject the traceparent/baggage headers in CORS preflight
          propagateTraceHeaderCorsUrls: [
            new RegExp(`^${API_BASE_URL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}`),
          ],
          ignoreUrls: [/googleapis/, /health-check/, /private/, /sentry/],
          clearTimingResources: true,
        },
      }),
    ],
  })
}
